<script>
import Layout from '@layouts/main'
import CSettingsDeviceActivityDetails from '@components/settings-device-activity-details'

import {
  deviceActivityMethods,
  deviceActivityComputed,
  infoMethods,
} from '@state/helpers'

export default {
  page() {
    return {
      title: 'Device Activity',
    }
  },

  components: { Layout, CSettingsDeviceActivityDetails },

  data: () => {
    return {
      fields: [
        { key: 'name', label: 'Activity Name', sortable: true },
        { key: 'id', label: 'Activity Id', sortable: true },
      ],
    }
  },

  computed: {
    ...deviceActivityComputed,
  },

  methods: {
    ...deviceActivityMethods,
    ...infoMethods,

    rowSelected(obj) {
      this.selectActivity({ activity: obj[0] })
    },

    newActivity(obj) {
      this.selectActivity({
        activity: { name: 'New Activity' },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <b-row class="animated fadeIn">
      <b-col lg="7">
        <BaseTable
          :table-data="cachedActivities"
          :fields="fields"
          hover="hover"
          striped="striped"
          caption="Device Activity List"
          :row-selected="rowSelected"
        >
          <template v-slot:buttons>
            <b-button class="float-right" variant="primary" @click="newActivity">
              New Activity
            </b-button>
          </template>
        </BaseTable>
      </b-col>

      <b-col lg="5">
        <collapse-transition :duration="250">
          <CSettingsDeviceActivityDetails
            v-if="selectedActivity"
            :key="selectedActivity.id"
          />
        </collapse-transition>
      </b-col>
    </b-row>
    <!--/.row-->
  </Layout>
</template>
